import { __rest, __assign } from '../../../node_modules/tslib/tslib.es6.js';
import React__default__default from 'react';
import PropTypes__default from 'prop-types';
import { NAV_ELEMS } from './types.js';

var NavElem = function (_a) {
  var Elem = _a.Elem,
    children = _a.children,
    href = _a.href,
    RouterLink = _a.RouterLink,
    innerRef = _a.innerRef,
    _b = _a.active,
    active = _b === void 0 ? false : _b,
    rest = __rest(_a, ["Elem", "children", "href", "RouterLink", "innerRef", "active"]);
  if (RouterLink) {
    var routerLinkRest = __assign(__assign(__assign({}, active ? {
      'aria-current': 'page'
    } : {}), innerRef ? {
      innerRef: innerRef
    } : {}), rest);
    return /*#__PURE__*/React__default__default.createElement(RouterLink, __assign({
      to: href || routerLinkRest.to || ''
    }, routerLinkRest), children);
  }
  switch (Elem) {
    case 'button':
      {
        var buttonRest = rest;
        return /*#__PURE__*/React__default__default.createElement("button", __assign({
          ref: innerRef,
          type: "button",
          "aria-current": active ? 'page' : undefined
        }, buttonRest), children);
      }
    case 'a':
      {
        var anchorRest = rest;
        return /*#__PURE__*/React__default__default.createElement("a", __assign({
          ref: innerRef,
          "aria-current": active ? 'page' : undefined
        }, anchorRest, {
          href: href
        }), children);
      }
    case 'div':
      {
        var divRest = rest;
        return /*#__PURE__*/React__default__default.createElement("div", __assign({
          ref: innerRef,
          "aria-current": active ? 'page' : undefined
        }, divRest), children);
      }
    default:
      {
        var spanRest = rest;
        return /*#__PURE__*/React__default__default.createElement("span", __assign({
          ref: innerRef,
          "aria-current": active ? 'page' : undefined
        }, spanRest), children);
      }
  }
};
NavElem.displayName = 'NavElem';
NavElem.propTypes = {
  Elem: PropTypes__default.oneOf(NAV_ELEMS),
  children: PropTypes__default.node.isRequired,
  active: PropTypes__default.bool,
  href: PropTypes__default.string,
  RouterLink: PropTypes__default.oneOfType([PropTypes__default.func, PropTypes__default.object]),
  innerRef: PropTypes__default.oneOfType([PropTypes__default.func, PropTypes__default.shape({
    current: PropTypes__default.object
  })])
};

export { NavElem };
